<template>
	<el-card class="el-card">
		<div class="time_table">
			<div>
				<el-date-picker
					v-model="valuetime"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="time"
				>
				</el-date-picker>
			</div>

			<el-select v-model="trade" placeholder="全部交易类型" @change="payType">
				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
			</el-select>
		</div>
		<div class="table_pay">
			<div v-if="trade == null || trade == 2">
				累计购买：<span class="red">{{ totalBuy }}元</span>
			</div>
			<div v-if="trade == null || trade == 1">
				累计充值：<span class="green">{{ totalAmount }}元</span>
			</div>
		</div>

		<div class="table">
			<el-table
				:data="tableData"
				style="width: 100%"
				:header-cell-style="{ background: '#eef1f6' }"
				v-loading="loading"
			>
				<el-table-column prop="product" label="交易商品"> </el-table-column>
				<el-table-column prop="typeDesc" align="center" label="交易类型"> </el-table-column>
				<el-table-column align="center" label="交易金额">
					<template slot-scope="scope">
						<div :class="scope.row.amountDesc > 0 ? 'green' : 'red'">{{ scope.row.amountDesc }} 元</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="created_at" label="交易时间"> </el-table-column>
			</el-table>
		</div>
		<div class="toolbar large-list">
			<div class="pagination-group">
				<el-pagination
					:background="true"
					:page-sizes="[30, 50, 100]"
					:page-size.sync="pageSize"
					:current-page.sync="page"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					@size-change="getFlow"
					@current-change="getFlow"
				/>
			</div>
		</div>
	</el-card>
</template>

<script>
import { Flow } from '@/utils/api'
export default {
	data() {
		return {
			loading: false,
			tableData: [],
			pageSize: 30,
			page: 1,
			total: 0,
			valuetime: [], //时间
			trade: null, //交易类型
			options: [
				{ id: null, name: '全部交易类型' },
				{ id: 1, name: '充值' },
				{ id: 2, name: '购买' },
			],
			start: null, //开始时间
			end: null, //结束时间
			totalAmount: 0, //累计充值金额
			totalBuy: 0, //累计购买金额
		}
	},
	mounted() {
		this.getFlow()
	},
	methods: {
		getFlow() {
			this.loading = true
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				type: this.trade,
				start: this.start || null,
				end: this.end || null,
				page: this.page,
				perPage: this.pageSize,
			}
			Flow(params).then((res) => {
				this.loading = false
				this.totalAmount = res.totalAmount
				this.totalBuy = res.totalBuy
				this.tableData = res.data
				this.total = res.total
			})
		},
		//选择类型
		payType() {
			this.page = 1
			this.getFlow()
		},
		//选择时间
		time(val) {
			if (val) {
				this.start = this.formatDateTime(val[0])
				this.end = this.formatDateTime(val[1])
			} else {
				this.start = null
				this.end = null
			}
			this.page = 1
			this.getFlow()
		},
		// 日期格式化
		formatDateTime(date) {
			const y = date.getFullYear()
			let m = date.getMonth() + 1
			m = m < 10 ? `0${m}` : m
			let d = date.getDate()
			d = d < 10 ? `0${d}` : d
			return `${y}-${m}-${d}`
		},
	},
}
</script>

<style scoped>
.el-card {
	padding-bottom: 52px;
	position: relative;
}
.table {
	padding-bottom: 60px;
}
.el-table__header-wrapper {
	height: 30px;
}
.condition {
	font-weight: bold;
}
.condition_i {
	vertical-align: middle;
	width: 16px;
	display: inline-block;
	cursor: pointer;
}
.toolbar {
	text-align: right;
	padding: 10px 10%;
	height: 32px;
	width: 80%;
	background-color: #fff;
}
.large-list {
	position: fixed;
	right: 37px;
	bottom: 0;
}
.status {
	width: 5px;
	height: 5px;
	border-radius: 50%;
	display: inline-block;
	vertical-align: middle;
	margin-right: 2px;
}
.notstart {
	background-color: #ccc;
}
.executed {
	background-color: #52c41a;
}
.effect {
	background-color: #1890ff;
}
.failed {
	background-color: #ff4d4f;
}
.statusText {
	vertical-align: middle;
}
.table_pay {
	font-size: 13px;
	display: flex;
	margin-bottom: 20px;
}
.table_pay > div:first-child {
	margin-right: 40px;
}
.red {
	color: red;
}
.green {
	color: green;
}
.time_table {
	display: flex;
	margin-bottom: 20px;
}
.time_table > div:first-child {
	margin-right: 40px;
}
</style>
